<template>
  <div id="AssessmentRules">
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
    <ots-refer :selectList="selectList" :requestForm="requestForm" @search="search"></ots-refer>
    <div class="mainCon">
      <el-button type="primary" style="margin-bottom: 8px;" @click="setRules" round plain :disabled="planInfo.scorePublish == 1">批量设置考核规则</el-button>
      <span style="margin-left: 16px; font-weight: 700; color: #FE5859;">说明：1、成绩占比为0的，不参与成绩核算！   2、参与本批次第三方成绩核算的考试状态为：{{ planSetStatusNames }}</span>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" :header-cell-style="{textAlign: 'center'}" :cell-style="{'text-align': 'center'}" @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column prop="planName" label="考试批次" >
        </el-table-column>
        <el-table-column prop="courseName" label="课程名称" >
        </el-table-column>
        <el-table-column v-for="item in tableColunm.length" :key="item" :label="tableColunm[item - 1].typeName + '占比'">
          <template slot-scope="scope">
            <el-input class="typeProportion" :disabled="tableColunm.length <= 1 || planInfo.scorePublish == 1" v-model.number="scope.row.typeProportionList[item - 1].typeProportion" oninput="value=value.replace(/\D/g,'')" ></el-input>
            <span> %</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" >
          <template slot-scope="scope">
            <el-button @click="SaveType(scope.row)" type="text" :disabled="tableColunm.length <= 1 || planInfo.scorePublish == 1">保存</el-button>
          </template>
        </el-table-column>
      </el-table>
      <ots-pagination :pagination="pagination" @changeNum="changeNum" @changePage="changePage"></ots-pagination>
    </div>

    <ots-custom-dialog :dialog.sync="setRulesDialog" title="批量设置考核规则" width="50%">
      <template v-slot:content>
        <div style="margin-bottom: 16px;">
          <span>
            <span style="display: inline-block; min-width: 120px; text-align: right;">考试批次：</span>
            {{ planInfo.name }}
          </span>
        </div>
        <ul>
          <li v-for="item in tableColunm" :key="item.planTypeId" style="margin-bottom: 8px;">
            <span style="display: inline-block; min-width: 120px; text-align: right; margin-right: 8px;" >{{item.typeName}}占比：</span>
            <el-input v-model.number="item.typeProportion" oninput="value=value.replace(/\D/g,'')"></el-input>
            <span>&nbsp;%</span>
          </li>
        </ul>
      </template>
      <template v-slot:footer>
        <el-button round @click="setRulesDialog = false">取消</el-button>
        <el-button round @click="Save" plain type="primary">保存</el-button>
      </template>
    </ots-custom-dialog>

    <ots-custom-dialog :dialog.sync="examStatusInfo.dialogVisible" title="设置考试状态" width="500px">
      <template v-slot:content>
        <div class="statusCss">
          <div>1、选择考试批次：</div>
          <div class="planCss">
            <el-select v-model="examStatusInfo.planId" filterable placeholder="请选择">
              <el-option
                v-for="item in examStatusInfo.planList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div>
            <div>2、勾选参与核算的考试状态：</div>
            <el-checkbox-group v-model="examStatusInfo.statusIdList" class="checkCss">
              <el-checkbox v-for="item in examStatusInfo.statusList" :label="item.id" :key="item.id" :disabled="item.disabled">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="examStatusInfo.dialogVisible = false">取消</el-button>
        <el-button round @click="saveExamStatus" type="primary">保存</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import { getSelectPlanFn, getSinglePlan } from "@/http/modules/examSet/examBatch";
import { getPlanCourseList } from "@/http/modules/custom";
import { 
  getTypeSetListAPI,
  operationTypeSetAPI,
  getBatchTypeSetInfoAPI,
  batchOperationTypeSetAPI,
  savePlanCheckStateScopeFn,
  getPlanCheckStateScopeFn
} from "@/http/modules/examSet/score";
export default {
  data() {
    return {
      multipleSelection: [],
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          isSearch: true,
          value: "id",
          data: [],
        },
        {
          title: "课程名称",
          type: "select",
          requestKey: "courseIds",
          label: "courseName",
          multiple: true,
          isSearch: true,
          value: "courseId",
          data: []
        }
      ],
      requestForm: {
        planId: "",
        courseIds: "",
        size: 10,
        page: 1,
      },
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "第三方成绩项",
          prop: "typeNameList",
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "设置",
              click: this.setConfig,
            },
            {
              title: "删除",
              click: this.delete,
            },
          ],
        },
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
      setRulesDialog: false,
      tableColunm: [],
      planInfo: {},
      examStatusInfo:{
        dialogVisible: false,
        planId: "",
        planList: [],
        statusIdList: [1],
        statusList: [
          {id:1,name:"正常",disabled:true},
          {id:2,name:"缺考",disabled:false},
          {id:3,name:"作弊",disabled:false},
          {id:4,name:"违纪",disabled:false},
          {id:5,name:"替考",disabled:false},
        ],
      },
      mainTopBtnList: [
        {
            title: "设置考试状态",
            fn: this.setExamStatus,
        },
      ],
      planSetStatusNames: '',
    }
  },
  watch: {
    "requestForm.planId": function (planId) {
      this.getPlanCourse(planId);
      this.getPlanInfo(planId);
      this.getPlanSetStatusNames(planId);
      this.$nextTick(async () => {
        await this.search();
        await this.getBatchTypeInfo(planId);
      })
    },
    "examStatusInfo.planId": function (planId) {
      if(planId){
        this.getExamStatus();
      }
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 初始化数据
    async initData() {
      const { code, data } = await getSelectPlanFn();
      if (code) {
        this.selectList[0].data = [...data];
        this.requestForm.planId = data[0].id;
        this.examStatusInfo.planList = [...data];
        this.examStatusInfo.planId = data[0].id;
      }
    },

    // 课程列表
    getPlanCourse(val){
      this.requestForm.courseIds = '';
      getPlanCourseList({planId:val}).then(({data})=>{
        this.selectList[1].data = [...data];
      })
    },

    // 批次详情
    async getPlanInfo(planId) {
      const { code, data } = await getSinglePlan({planId});
      if (code) {
        this.planInfo = data;
      }
    },

    // 搜索
    async search() {
      this.requestForm.page = 1;
      await this.getTableList();
    },

    // 获取表格数据
    async getTableList() {
      let params = {...this.requestForm}
      params.courseIds = params.courseIds.length > 0 ? params.courseIds.join(): "";
      const { code, data } = await getTypeSetListAPI(params);
      if (code) {
        this.tableData = data.records;
        this.pagination.total = data.total;
      }
    },

    // 获取规则
    async getBatchTypeInfo(planId) {
      const { code, data } = await getBatchTypeSetInfoAPI({planId});
      if (code && data ) {
        this.tableColunm = data;
      }
    },

    // 设置规则
    async setRules() {

      if (this.tableColunm.length <= 1) {
        this.$message.warning("该考试批次未设置第三方成绩项。");
        return;
      }

      if (this.multipleSelection.length == 0) {
        this.$message.error("请勾选要设置的数据！");
        return false;
      }
      this.setRulesDialog = true;
    },

    // 保存设置规则
    async Save() {
      let planId = this.requestForm.planId;
      let tableColunm = JSON.parse(JSON.stringify(this.tableColunm));
      let typeProportions = {}
      tableColunm.map(e=>{
        typeProportions[e.planTypeId] = e.typeProportion;
      })
      typeProportions = JSON.stringify(typeProportions);
      typeProportions = typeProportions.replace(/"/g, '');
      let courseIds = [];
      this.multipleSelection.map(e=>{
        courseIds.push(e.courseId);
      })
      let params = {
        planId,
        typeProportions: typeProportions.substring(1, typeProportions.length - 1),
        courseIds: courseIds.join(",")
      }
      const { code } = await batchOperationTypeSetAPI(params);
      if (code) {
        this.$message.success("批量设置成功！");
        this.getTableList();
        this.setRulesDialog = false;
      }
    },
    async SaveType(row) {
      let params = {
        planId: row.planId,
        courseId: row.courseId,
        typeProportions: JSON.stringify(row.typeProportionList),
      }
      const { code } = await operationTypeSetAPI(params);
      if (code) {
        this.$message.success("保存成功！");
        this.getTableList();
      }
    },
    changeNum(num) {
      this.requestForm.size = num;
      this.getTableList();
    },
    changePage(p) {
      this.requestForm.page = p;
      this.getTableList();
    },
    setExamStatus() {
      this.getExamStatus();
      this.examStatusInfo.dialogVisible = true;
    },
    async getExamStatus() {
      await getPlanCheckStateScopeFn({planId:this.examStatusInfo.planId}).then(({code,data})=>{
        if (code) {
          this.examStatusInfo.statusIdList = data.filter(item=>item.checked).map(item=>item.id);
        }
      })
    },
    async saveExamStatus(){
      let params = {
        planId: this.examStatusInfo.planId,
        checkStateList: this.examStatusInfo.statusIdList.join(",")
      }
      const { code,data } = await savePlanCheckStateScopeFn(params);
      if (code) {
        this.$message.success("设置成功！");
        this.examStatusInfo.dialogVisible = false;
        this.getPlanSetStatusNames(this.requestForm.planId);
      }
    },
    async getPlanSetStatusNames(val) {
      await getPlanCheckStateScopeFn({planId:val}).then(({code,data})=>{
        if (code) {
          this.planSetStatusNames = data.filter(item=>item.checked).map(item=>item.name).join("/");
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.el-input {
  width: 96px;
}
/deep/ .el-input__inner,.typeProportion {
  width: 96px;
}
.statusCss{
  font-size: 14px;
  .planCss{
    margin:15px 0px 15px 20px;
    /deep/ .el-input{
      width: 300px !important;    }
    /deep/ .el-input__inner{
      width: 300px !important;
    }
  }
  .checkCss{
    text-align: center;
    margin:15px 0px;
  }
}
</style>